export default __webpack_public_path__ + "static/media/excel-icon.972d6637.svg";